import React from 'react';
import Comments from '../../../Elements/Comments';
import TabbedPage from '../../../Elements/TabbedPage';
import ClientPaymentDetailsInfoTab from './ClientPaymentDetailsInfoTab';
import ClientPaymentDetailsInvoiceTab from './ClientPaymentDetailsInvoiceTab';
import ClientPaymentDetailsRefundTab from './ClientPaymentDetailsRefundTab';

export default class ClientPaymentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  clientPaymentId = this.urlParams.get('id');

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Client Payment ${id ? '- ' + id : 'Details'}`;
  }

  tabs = [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <ClientPaymentDetailsInfoTab clientPaymentId={this.clientPaymentId} />
    },
    {
      label: 'Client Invoices',
      id: 'clientinvoices',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <ClientPaymentDetailsInvoiceTab clientPaymentId={this.clientPaymentId} />
    },
    {
      label: 'Refunds',
      id: 'refunds',
      icon: 'fa-solid fa-dollar-sign',
      component: <ClientPaymentDetailsRefundTab clientPaymentId={this.clientPaymentId} />
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comment',
      component: <Comments entityTypeId={33} entityId={this.clientPaymentId} />
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
